import React from 'react';

import { useTranslation } from 'react-i18next';

import BlockList from 'components/application/BlockList';

export default function RolesSidePanelCoursesTab({ courseCollection }) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  // order courseCollection alphabetically
  const orderedCourseCollection = [...courseCollection].sort((a, b) =>
    a.courseName.localeCompare(b.courseName, 'en', { sensitivity: 'base' }),
  );

  return (
    <div key='coursesTab' label='courses'>
      <BlockList
        collection={orderedCourseCollection}
        onItemDisplay={(course) => (
          <div className='tw-flex tw-flex-col'>
            <span className='tw-text-grey-700'>{course.courseName}</span>
            <span className='tw-text-s tw-text-grey-500'>
              {course.required ?
                i18nTShared('required')
              : i18nTShared('optional')}
            </span>
          </div>
        )}
      />
    </div>
  );
}
